/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

import { api, mutatingPost, type ApiResult } from "./client";
import type { PayerRef } from "./runs";

/** One scheduling-pool candidate, named server-side. */
export type PoolCandidate = {
  patientId: string;
  familyId: number | null;
  firstName: string | null;
  lastName: string | null;
  healthieId: string | null;
  source: "WAITLIST" | "TRANSITION" | null;
  sourceId: string | null;
  state: string | null;
  payer: PayerRef | null;
  acuity: string | null;
  flexibility: string | null;
  addedAt: string | null;
  eligibility: string | null;
  eligibilityReason: string | null;
  reachable: boolean;
};

export type WaitlistRemoval = { entryId: string; status: string };

export function poolPreview(state: string): Promise<ApiResult<PoolCandidate[]>> {
  return api<PoolCandidate[]>(`/v1/admin/pool?state=${encodeURIComponent(state)}`);
}

/**
 * Takes a family off the waitlist so the agent stops offering it slots. A new waitlist note in
 * Healthie adds the family back; re-reading an old note never does.
 */
export function removeFromWaitlist(
  entryId: string,
  idempotencyKey: string,
): Promise<ApiResult<WaitlistRemoval>> {
  return api<WaitlistRemoval>(
    `/v1/admin/waitlist/${encodeURIComponent(entryId)}/remove`,
    mutatingPost({}, idempotencyKey),
  );
}
